import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import SingleColumn from "../components/content/single-column"
import Grid from "../components/grid"
import "prismjs/themes/prism-okaidia.css"

import Hero from "../components/hero"
import {MDXRenderer} from "gatsby-plugin-mdx"

const MainPage = ({data, location}) => {
  const children = data.children.edges.map((child) => {
    const {frontmatter: fm, fields} = child.node
    return {
      title: fm.title,
      link: fields.slug,
      image: {...fm.icon.data.resolutions},
      text: fm.description
    }
  })
  const post = data.mdx

  return (
    <Layout location={location}>
      <SEO title={post.frontmatter.title} {...post.frontmatter} />
      <div className="full_width">
        <div className="full_width_inner">
          <Hero {...post.frontmatter} />
          <SingleColumn>
            <MDXRenderer>{post.body}</MDXRenderer>
            <Grid items={children} />
          </SingleColumn>
        </div>
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($slug: String!) {
    mdx(slug: { eq: $slug}) {
      body
      frontmatter {
        slug
        title
        template
        heroVideoURL
        heroBackgroundImage{
						data: childImageSharp {
                resolutions(width: 1200) {
                  width
                  height
                  src
                  srcSet
                }
              
          }}
        heroH1
        heroH2
        heroText
        heroCTAText
        heroCTALink
				heroCaption
      }
      headings {
        value
        depth
      }
      tableOfContents(maxDepth: 3)
    }
    children: allMdx(
      filter: { fields: { parent: { eq: $slug }, order: { gt: 0 } } }
			sort: {fields: [frontmatter___order], order: ASC}
    ) {
      edges {
        node {
          fields {
            slug
            featured
          }
          frontmatter {
            slug
            title
            description
            icon {
              data: childImageSharp {
                resolutions(width: 87) {
                  width
                  height
                  src
                  srcSet
                }
              }
            }
          }
        }
      }
    }
  }
`

export default MainPage
